// extracted by mini-css-extract-plugin
module.exports = {"container":"_2HoJJCQC56jCiu-x6Cauut"};